// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const zh_cn_pmainweblink3 = /** @type {(inputs: {}) => string} */ () => {
	return `图标网站`
};

const en_pmainweblink3 = /** @type {(inputs: {}) => string} */ () => {
	return `Website`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "zh-cn" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pmainweblink3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pmainweblink3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pmainweblink3", locale)
	if (locale === "zh-cn") return zh_cn_pmainweblink3(inputs)
	if (locale === "en") return en_pmainweblink3(inputs)
	return "pMainWebLink"
};
export { pmainweblink3 as "pMainWebLink" }